<template>
  <div v-show="nbResults" class="toolbar">
    <div class="toolbar__nbresults">{{ countMessage }}</div>
    <!-- this part is fixed to the bottom on mobile 
      put the ShareDialog first because of a bug in IE11  
      https://stackoverflow.com/questions/32991051/absolutely-positioned-flex-item-is-not-removed-from-the-normal-flow-in-ie11
     -->
    <ShareDialog 
      :hidden="!showShareDialog"
      :link="linkSelected"
      :toggleShareDialog="toggleShareDialog"
    />
    <div class="toolbar__actions" v-bind:class="{ 'toolbar__actions--hidden': hidden }">
      <button class="toolbar__toggle" v-on:click="toggle"></button>
      <span class="toolbar__count">{{ (nbSelected) ? nbSelected : '&nbsp;' }}</span>
      <span class="toolbar__help" v-if="nbSelected === 0">
        Use <input class="customcheck" checked="checked" disabled="disabled" type="checkbox"/> to select, share and compare
      </span>
      <button v-if="nbSelected && !showSelected" class="toolbar__view-selected toolbar__action" v-on:click="setShowSelectedTrue"
        data-gtm-category="View selected/all" data-gtm-action="View selected" :data-gtm-label="linkSelected">View selected ({{nbSelected}})</button>
      <button v-if="nbSelected && showSelected" class="toolbar__view-all toolbar__action" v-on:click="setShowSelectedFalse"
        data-gtm-category="View selected/all" data-gtm-action="View all" data-gtm-label="All">View all</button>
      <button v-if="nbSelected" class="toolbar__share toolbar__action" v-on:click="toggleShareDialog"
        data-gtm-category="Share" data-gtm-action="Share" :data-gtm-label="linkSelected">Share</button>
      <button v-if="nbSelected" class="toolbar__print toolbar__action" v-on:click="print"
        data-gtm-category="Print" :data-gtm-action="(showSelected) ? 'Print selection' : 'Print'" :data-gtm-label="(showSelected) ? linkSelected : 'All'">Print</button>
      <button v-if="nbSelected" class="toolbar__clear toolbar__action" v-on:click="clearWatchlist">Clear</button>
      <button v-if="displayList" class="toolbar__grid toolbar__action" v-on:click="showGrid"
        data-gtm-category="View" data-gtm-action="View grid"  data-gtm-label="Switch to grid view">Grid</button>
      <button v-if="!displayList" class="toolbar__list toolbar__action" v-on:click="showList"
        data-gtm-category="View" data-gtm-action="View list"  data-gtm-label="Switch to list view">List</button>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import ShareDialog from './ShareDialog.vue';
  import { makeSticky } from '../services/dom.js';
  
  export default Vue.component('Toolbar', {
    props: {
      nbResults: Number,
      nbSelected: Number,
      linkSelected: String,
      showSelected: Boolean,
      setShowSelected: Function,
      clearWatchlist: Function,
      displayList: Boolean,
      setDisplayList: Function,
    },
    data: function() {
      return {
        showShareDialog: false,
        hidden: false,
      }
    },
    mounted: function () {
      makeSticky(this.$el, this.$el.nextElementSibling);
    },   
    watch: {
      // show the tollbar if it was hidden when the first card was selected
      nbSelected: function(newVal, oldVal) {
        if (newVal === 1 && oldVal === 0 && this.hidden === true) {
          this.toggle();
        }
        if (newVal === 0 && this.showShareDialog === true) {
          this.toggleShareDialog();
        }
      }
    },
    computed: {
      countMessage: function() {
        if (this.showSelected) {
          return `${this.nbSelected} Selected`;
        }
        return (this.nbResults > 1) ? `${this.nbResults} Results found` : `${this.nbResults} Result found`;
      },
    },
    methods: {
      toggleShareDialog: function() {
        this.showShareDialog = !this.showShareDialog;
      },
      toggle: function() {
        this.hidden = !this.hidden;
        if (this.hidden) {
          this.showShareDialog = false;
        }
      },
      setShowSelectedTrue: function() {
        this.setShowSelected({ showSelected: true });
      },
      setShowSelectedFalse: function() {
        this.setShowSelected({ showSelected: false });
      },
      print: () => window.print(),
      showList: function() {
        this.setDisplayList({ displayList: true });
      },
      showGrid: function() {
        this.setDisplayList({ displayList: false });
      },
    }
  });
</script>